
import ReactGA from 'react-ga';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Footer, Header } from './components';
import SinglePage from './pages/singlePage';
import { Single } from './sections';
import WebPage from './WebPage';
import { useTranslation } from 'react-i18next';
import EbookPage from './pages/ebookPage';


const TRACKING_ID = "UA-133866763-2";

ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname);


 function App() {
	const [t] = useTranslation();
	return (
		<Router>
			 <Header />
			<Routes>
				<Route path="/" element={<WebPage/>} exact/>
				<Route path="/solution" element={<SinglePage />}/>
				<Route path="/download-ebook" element={<EbookPage/>} />
				{/* Singles */}
					<Route path={t('single.single001.link')} element={
					<Single
						title={t('single.single001.title')}
						subtitle={t('single.single001.subTitle1')}
					>
						<p>
							{t('single.single001.description000')}
						</p>
						<p>
							{t('single.single001.description001')}
						</p>
						<p>
							{t('single.single001.description002')}
						</p>
						<h2>
							{t('single.single001.header100')} 
						</h2>
						<p>
							{t('single.single001.description100')}
						</p>

						<h2>
							{t('single.single001.header200')} 
						</h2>
						<p>
							{t('single.single001.description200')} 
						</p>
						<p>
							{t('single.single001.description201')} 
						</p>
						<h3>
							{t('single.single001.header300')} 
						</h3>
						<p>
							{t('single.single001.description300')} 
						</p>
						<h3> 
							{t('single.single001.header400')} 	
						</h3>
						<p>
							{t('single.single001.description400')} 
						</p>
						<h3>{t('single.single001.header500')}</h3>
						<p>
							{t('single.single001.description500')}
						</p>

						<h2>
							{t('single.container.contactHeader')} 
						</h2>
						<p>
							{t('single.container.contactDescription')}
						</p>
					</Single>
					}/>

					<Route path={t('single.single002.link')} element={
					<Single
						title={t('single.single002.title')}
						subtitle={t('single.single002.subTitle1')}
					>
						<p>
							{t('single.single002.description000')}
						</p>
						<p>
							{t('single.single002.description001')}
						</p>
						<p>
							{t('single.single002.description002')}
						</p>
						<h2>
							{t('single.single002.header100')} 
						</h2>
						<p>
							{t('single.single002.description100')}
						</p>

						<h2>
							{t('single.single002.header200')} 
						</h2>
						<p>
							{t('single.single002.description200')} 
						</p>
						<p>
							{t('single.single002.description201')} 
						</p>
						<p>
							{t('single.single002.description202')} 
						</p>
						<h3>
							{t('single.single002.header300')} 
						</h3>
						<p>
							{t('single.single002.description300')} 
						</p>
						<p>
							{t('single.single002.description301')} 
						</p>
						<h3> 
							{t('single.single002.header400')} 	
						</h3>
						<p>
							{t('single.single002.description400')} 
						</p>
						<h3>{t('single.single002.header500')}</h3>
						<p>
							{t('single.single002.description500')}
						</p>
						<h3>{t('single.single002.header600')}</h3>
						<p>
							{t('single.single002.description600')}
						</p>
						<h2>
							{t('single.single002.header700')} 
						</h2>
						<p>
							{t('single.single002.description700')}
						</p>
					</Single>
					}/>

					<Route path={t('single.single003.link')} element={
					<Single
						title={t('single.single003.title')}
						subtitle={t('single.single003.subTitle1')}
					>
						<p>
							{t('single.single003.description000')}
						</p>
						<p>
							{t('single.single003.description001')}
						</p>
						<p>
							{t('single.single003.description002')}
						</p>
						<h2>
							{t('single.single003.header100')} 
						</h2>
						<p>
							{t('single.single003.description100')}
						</p>
						<p>
							{t('single.single003.description101')}
						</p>
						<p>
							{t('single.single003.description102')}
						</p>

						<h2>
							{t('single.single003.header200')} 
						</h2>
						<p>
							{t('single.single003.description200')} 
						</p>
						<p>
							{t('single.single003.description201')} 
						</p>
						<p>
							{t('single.single003.description202')} 
						</p>
						<h3>
							{t('single.single003.header300')} 
						</h3>
						<p>
							{t('single.single003.description300')} 
						</p>
						<p>
							{t('single.single003.description301')} 
						</p>
						<h3> 
							{t('single.single003.header400')} 	
						</h3>
						<p>
							{t('single.single003.description400')} 
						</p>
						<h3>{t('single.single003.header500')}</h3>
						<p>
							{t('single.single003.description500')}
						</p>
						<h3>{t('single.single003.header600')}</h3>
						<p>
							{t('single.single003.description600')}
						</p>
						<h3>
							{t('single.single003.header700')} 
						</h3>
						<p>
							{t('single.single003.description700')}
						</p>
						<ul>
							<li>
							{t('single.single003.list701')}
							</li>
							<li>
							{t('single.single003.list702')}
							</li>
							<li>
							{t('single.single003.list703')}
							</li>
							<li>
							{t('single.single003.list704')}
							</li>
							<li>
							{t('single.single003.list705')}
							</li>
							<li>
							{t('single.single003.list706')}
							</li>
						</ul>
						<h3>{t('single.single003.header800')}</h3>
						<p>
							{t('single.single003.description800')}
						</p>
						<h3>{t('single.single003.header900')}</h3>
						<p>
							{t('single.single003.description900')}
						</p>
						<h2>{t('single.single003.header1000')}</h2>
						<p>
							{t('single.single003.description1000')}
						</p>
					</Single>
					}/>
					
					<Route path={t('single.single004.link')} element={
					<Single
						title={t('single.single004.title')}
						subtitle={t('single.single004.subTitle1')}
					>
						<p>
							{t('single.single004.description000')}
						</p>
						<p>
							{t('single.single004.description001')}
						</p>
						<h2>
							{t('single.single004.header100')} 
						</h2>
						<p>
							{t('single.single004.description100')}
						</p>
						<p>
							{t('single.single004.description101')}
						</p>
						<p>
							{t('single.single004.description102')}
						</p>

						<h2>
							{t('single.single004.header200')} 
						</h2>
						<p>
							{t('single.single004.description200')} 
						</p>
						<ul>
							<li>
							{t('single.single004.list201')}
							</li>
							<li>
							{t('single.single004.list202')}
							</li>
							<li>
							{t('single.single004.list203')}
							</li>
							<li>
							{t('single.single004.list204')}
							</li>
							<li>
							{t('single.single004.list205')}
							</li>
							<li>
							{t('single.single004.list206')}
							</li>
						</ul>
						<h3>
							{t('single.single004.header300')} 
						</h3>
						<p>
							{t('single.single004.description300')} 
						</p>
						<h3> 
							{t('single.single004.header400')} 	
						</h3>
						<p>
							{t('single.single004.description400')} 
						</p>
						<h3>{t('single.single004.header500')}</h3>
						<p>
							{t('single.single004.description500')}
						</p>
						<h3>{t('single.single004.header600')}</h3>
						<p>
							{t('single.single004.list600')}
						</p>
						<ul>
							<li>
								{t('single.single004.list601')}
							</li>
							<li>
								{t('single.single004.list602')}
							</li>
							<li>
								{t('single.single004.list603')}
							</li>
							<li>
								{t('single.single004.list604')}
							</li>
							<li>
								{t('single.single004.list605')}
							</li>
							<li>
								{t('single.single004.list606')}
							</li>
							<li>
								{t('single.single004.list607')}
							</li>
						</ul>
						<h3>
							{t('single.single003.header700')} 
						</h3>
						<p>
							{t('single.single003.description700')}
						</p>
						<h3>
							{t('single.single004.header800')} 
						</h3>
						<p>
							{t('single.single004.description800')}
						</p>
						<h3>
							{t('single.single004.header900')} 
						</h3>
						<p>
							{t('single.single004.description900')}
						</p>
						
					</Single>
					}/>

					<Route path={t('single.single005.link')} element={
					<Single
						title={t('single.single005.title')}
						subtitle={t('single.single005.subTitle1')}
					>
						<p>
							{t('single.single005.description000')}
						</p>
						<p>
							{t('single.single005.description001')}
						</p>
						<h2>
							{t('single.single005.header100')} 
						</h2>
						<p>
							{t('single.single005.description100')}
						</p>
						<p>
							{t('single.single005.description101')}
						</p>
						<p>
							{t('single.single005.description102')}
						</p>
						<p>
							{t('single.single005.description103')}
						</p>
						<h2>
							{t('single.single005.header200')} 
						</h2>
						<p>
							{t('single.single005.description200')} 
						</p>
						<p>
							{t('single.single005.description201')} 
						</p>
						<p>
							{t('single.single005.description202')} 
						</p>
						<ul>
							<li>
							{t('single.single005.list200')}
							</li>
						</ul>
						<p>
							{t('single.single005.description201')}
						</p>
						<ol>
							<li>
							{t('single.single005.bullet201')}
							</li>
							<li>
							{t('single.single005.bullet202')}
							</li>
							<li>
							{t('single.single005.bullet203')}
							</li>
							<li>
							{t('single.single005.bullet204')}
							</li>
							<li>
							{t('single.single005.bullet205')}
							</li>
						</ol>
						<ul>
							<li>
								{t('single.single005.list201')}
							</li>
							<li>
								{t('single.single005.list202')}
							</li>
						</ul>
						<p>
							{t('single.single005.description204')} 
						</p>
						<ul>
							<li>
								{t('single.single005.list203')}
							</li>
							<li>
								{t('single.single005.list204')}
							</li>
						</ul>
						<h3>
							{t('single.single005.header300')} 
						</h3>
						<p>
							{t('single.single005.description300')} 
						</p>
						<h3> 
							{t('single.single005.header400')} 	
						</h3>
						<p>
							{t('single.single005.description400')} 
						</p>
						<ul>
							<li>
								{t('single.single005.bullet401')}
							</li>
							<li>
								{t('single.single005.bullet402')}
							</li>
							<li>
								{t('single.single005.bullet403')}
							</li>
							<li>
								{t('single.single005.bullet404')}
							</li>
							<li>
								{t('single.single005.bullet405')}
							</li>
							<li>
								{t('single.single005.bullet406')}
							</li>
							<li>
								{t('single.single005.bullet407')}
							</li>
							<li>
								{t('single.single005.bullet408')}
							</li>
							<li>
								{t('single.single005.bullet409')}
							</li>
							<li>
								{t('single.single005.bullet410')}
							</li>
							<li>
								{t('single.single005.bullet411')}
							</li>
							<li>
								{t('single.single005.bullet412')}
							</li>
							<li>
								{t('single.single005.bullet413')}
							</li>
							<li>
								{t('single.single005.bullet414')}
							</li>
							<li>
								{t('single.single005.bullet415')}
							</li>
							<li>
								{t('single.single005.bullet416')}
							</li>
						</ul>
						<h3>{t('single.single005.header500')}</h3>
						<p>
							{t('single.single005.description500')}
						</p>
						<p>
							{t('single.single005.description501')}
						</p>
						
						<h3>
							{t('single.single005.header600')} 
						</h3>
						<p>
							{t('single.single005.description600')}
						</p>
						<h3>
							{t('single.single005.header700')} 
						</h3>
						<p>
							{t('single.single005.description700')}
						</p>

					</Single>
					}/>

					<Route path={t('single.single006.link')} element={
					<Single
						title={t('single.single006.title')}
						subtitle={t('single.single006.subTitle1')}
					>
						<p>
							{t('single.single006.description000')}
						</p>
						<p>
							{t('single.single006.description001')}
						</p>
						<h2>
							{t('single.single006.header200')} 
						</h2>
						<p>
							{t('single.single006.description200')}
						</p>
						<p>
							{t('single.single006.description201')}
						</p>
						<p>
							{t('single.single006.description202')}
						</p>

						<h2>
							{t('single.single006.header200')} 
						</h2>
						<p>
							{t('single.single006.description200')} 
						</p>
						<p>
							{t('single.single006.description201')} 
						</p>
						<p>
							{t('single.single006.description202')} 
						</p>
						<h2>
							{t('single.single006.header300')} 
						</h2>
						<p>
							{t('single.single006.description300')} 
						</p>
						<p>
							{t('single.single006.description301')} 
						</p>
						<p>
							{t('single.single006.description302')} 
						</p>
						<ul>
							<li>
								{t('single.single006.bullet301')} 
							</li>
							<li>
								{t('single.single006.bullet302')} 
							</li>
						</ul>
						<h2>
							{t('single.single006.header400')} 
						</h2>
						<p>
							{t('single.single006.description400')} 
						</p>
						<h3>
							{t('single.single006.header500')} 
						</h3>
						<p>
							{t('single.single006.description500')} 
						</p>
						<h3>
							{t('single.single006.header600')} 
						</h3>
						<p>
							{t('single.single006.description600')} 
						</p>
						<p>
							{t('single.single006.description601')} 
						</p>
						<ul>
							<li>
								{t('single.single006.bullet601')} 
							</li>
							<li>
								{t('single.single006.bullet602')} 
							</li>
							<li>
								{t('single.single006.bullet603')} 
							</li>
							<li>
								{t('single.single006.bullet604')} 
							</li>
						</ul>
						<h3>
							{t('single.single006.header700')} 
						</h3>
						<p>
							{t('single.single006.description700')} 
						</p>
						<h3>
							{t('single.single006.header800')} 
						</h3>
						<p>
							{t('single.single006.description800')} 
						</p>
						<h2>
							{t('single.single006.header900')} 
						</h2>
						<p>
							{t('single.single006.description900')} 
						</p>
					</Single>
					}/>

					<Route path={t('single.single007.link')} element={
					<Single
						title={t('single.single007.title')}
						subtitle={t('single.single007.subTitle1')}
					>
						<p>
							{t('single.single007.description000')}
						</p>
						<p>
							{t('single.single007.description001')}
						</p>
						<h2>
							{t('single.single007.header100')} 
						</h2>
						<p>
							{t('single.single007.description100')}
						</p>
						<p>
							{t('single.single007.description101')}
						</p>
						<h2>
							{t('single.single007.header200')} 
						</h2>
						<p>
							{t('single.single007.description200')}
						</p>
						<p>
							{t('single.single007.description201')}
						</p>
						<ul>
							<li>
								{t('single.single007.bullet201')}
							</li>
							<li>
								{t('single.single007.bullet202')}
							</li>
						</ul>
						<h2>
							{t('single.single007.header300')} 
						</h2>
						<p>
							{t('single.single007.description300')}
						</p>
						<h3>
							{t('single.single007.header400')} 
						</h3>
						<p>
							{t('single.single007.description400')}
						</p>
						<h3>
							{t('single.single007.header500')} 
						</h3>
						<p>
							{t('single.single007.description500')}
						</p>
						<h3>
							{t('single.single007.header600')} 
						</h3>
						<p>
							{t('single.single007.description600')}
						</p>
						<h3>
							{t('single.single007.header700')} 
						</h3>
						<p>
							{t('single.single007.description700')}
						</p>
						<h2>
							{t('single.single007.header800')} 
						</h2>
						<p>
							{t('single.single007.description800')}
						</p>
					</Single>
					}/>
			</Routes>
			<Footer />
		</Router>
	);
}

export default App;
